// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"d7edb911","277":"0e302a65"}[chunkId] + ".chunk.js";
};